<span (click)='switch()'
    [class.selected]="isSelected">
  {{label}}
</span>
